var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandSimulate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BrandSimulate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3438 1L12.1782 1.09333V1.09567L8.44717 7.468L13.0718 15.364L12.2552 16.757L12.2633 16.771H12.247L12.2552 16.757L7.6305 8.861L3 16.771H6.06833L7.6025 14.1507L7.6305 14.1017L7.65967 14.1507L12.2552 22L14.6048 17.9843V17.9832L16.1402 15.3628L11.5178 7.46683L12.3345 6.07383L16.9568 13.9698L17.0642 14.1507L18.5972 16.771H21.6667L12.4745 1.0735L12.3438 1Z",
    fill: "#F6B52D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandSimulate);
export default __webpack_public_path__ + "static/media/brandSimulate.a482017f30403996bc3079edae293fe9.svg";
export { ForwardRef as ReactComponent };